import $ from 'jquery';

require('slick-carousel/slick/slick');

$('.header__background_slides').slick({
		autoplay: true,
		autoplaySpeed: 4000,
		dots: true,
		appendDots: $('.header__foreground_dots'),
		prevArrow: $('.header__foreground_prev'),
		nextArrow: $('.header__foreground_next'),
		asNavFor: '.header__foreground_slider',
	}
);
$('.header__foreground_slider').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	fade: true,
	asNavFor: '.header__background_slides'
});


$('.partner-slider__image-slide').slick({
	autoplay: true,
	dots: true,
	infinite: true,
	arrows: true,
	speed: 400,
	slidesToShow: 5,
	slidesToScroll: 1,
	prevArrow: $('.custom-slick-prev'),
	nextArrow: $('.custom-slick-next'),
	appendDots: $('.partner-slider__dots'),
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 3,
			}
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
			}
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
			}
		}
	]
});
